import Vue from 'vue'
import Vuex, {ActionContext} from 'vuex'
import { IMenuConfig, mainItemsOrder } from "@/model/menu/IMenuConfig";
import {IMenuEntity} from "@/model/menu/IMenuEntity";
import {startMicroFronts} from "@/services/micro-front-service";
import {isMenuAvailable, prepareSubMenus, startTimer} from "@/services/auth-service";
import {IApplication} from "@/model/config/IApplication";
import {IOnDemandApplication} from "@/model/config/IOnDemandApplication";
import {Subject} from "rxjs";
import {SharedStore} from "water-rest/src/model/sharedStore/SharedStore";
import {IAuthData} from "@/model/IAuthData";
import {IHeaderInfo} from "water-rest/src/model/sharedStore/IHeaderInfo";
import GlobalStore from "water-rest/src/store/GlobalStore";
import {BreadcrumbsConfig, ModuleSystem} from "water-rest/src/model/GlobalTypes";
import {ThemeModule} from "@/store/theme-module";
import {ISettings, MapSettings, mapSettingsService} from "@/model/settings/MapSettings";
import {clearPaginationSettings} from 'water-layout/src/services/pagination-service';
import {Pageable} from 'water-rest/src/model/hateoas/Pageable';
import { sortMenuItems } from '@/services/micro-front-service';

Vue.use(Vuex);

export default new Vuex.Store({
  state: (): IState => ({
    authData: undefined,
    isAuthenticated: false,
    menu: Array<IMenuEntity>(),
    totalServices: 0,
    processedServices: 0,
    isServicesLoading: false,
    isServicesLoaded: false,
    subscriptionData: undefined,
    onDemandApplications: Array<IOnDemandApplication>(),
    onAuth: new Subject<IAuthData>(),
    systems: Array<ModuleSystem>(),
    settings: null,
    isForeign: false,
    linkDownloadApp: null,
    linkSettings: null,
  }),
  mutations: {
    setAuthData(state: IState, authData: IAuthData) {
      state.authData = authData;
      state.isAuthenticated = true;
    },
    setAuthDataInit(state: IState, authData: IAuthData) {
      localStorage.setItem( 'authData', JSON.stringify( authData ) );
      state.onAuth.next(authData);
      state.authData = authData;
      state.isAuthenticated = true;
      startTimer(authData);
    },
    setSystems(state: IState, systems: ModuleSystem[] | undefined) {
      if ( systems && Array.isArray(systems) ) state.systems = systems;
    },
    removeAuthData(state: IState) {
      localStorage.removeItem( 'authData' );
      localStorage.removeItem( 'clientUuid' );
      // localStorage.clear();
      clearPaginationSettings();
      state.authData = undefined;
      state.isAuthenticated = false;
    },
    addMenu(state: IState, menuConfig: IMenuConfig) {
      if ( menuConfig.menus ) {
        menuConfig.menus.forEach( (menu) => {
          if ( isMenuAvailable( menu, state.authData ) ) {
            prepareSubMenus(menu, state.authData);
            state.menu.push(menu);
          }
        } );
      }

      if ( menuConfig.sharedMenus ) {
        menuConfig.sharedMenus.forEach( (sharedMenu) => {
          if ( isMenuAvailable( sharedMenu, state.authData ) ) {
            const existing = state.menu.find((eachMenu: IMenuEntity) => eachMenu.name === sharedMenu.name);
            prepareSubMenus(sharedMenu, state.authData);

            if ( existing ) {
              if ( sharedMenu.subMenus && sharedMenu.subMenus.length > 0 ) {
                if ( !existing.subMenus ) existing.subMenus = [];
                sharedMenu.subMenus.forEach(el => {
                  if (el?.shared) {
                    const exist = existing.subMenus.find(
                      (menu) => menu.name === el.name
                    );

                    if (exist) {
                      if (!Array.isArray(exist?.subMenus)) {
                        exist.subMenus = [];
                      }
                      exist.subMenus.push(...el.subMenus);
                      sortMenuItems(exist.subMenus);
                    } else {
                      existing.subMenus.push(el);
                    }
                  } else {
                    existing.subMenus.push(el);
                  }
                })
                sortMenuItems(existing.subMenus);
              }

              if ( sharedMenu.routes && sharedMenu.routes.length > 0 ) {
                if ( !existing.routes ) existing.routes = [];
                existing.routes.push( ...sharedMenu.routes );
              }
            }
            else {
              state.menu.push(sharedMenu);
            }
          }
        } );
      }

      // Принудительная установка порядка пунктов меню.
      // Новые добавляемые основные пункты меню добавляются
      // после предустановленных и сортируются по названию
      const sortOrderOther = 1000;
      for (const item of state.menu) {
        if (mainItemsOrder[item.title]) {
          item.sortOrder = mainItemsOrder[item.title];
        } else {
          item.sortOrder = sortOrderOther;
        }
      }
      sortMenuItems(state.menu);
    },
    addTotalServices(state: IState, totalServices: number) {
      state.totalServices += totalServices;
    },
    incrementProcessedServices(state: IState, redirect: boolean) {
      state.processedServices++;
      if ( state.processedServices === state.totalServices ) {
        state.isServicesLoading = false;
        state.isServicesLoaded = true;
        startMicroFronts(redirect, state.menu);
      }
    },
    setServicesLoadStart(state: IState) {
      state.isServicesLoading = true;
    },
    clearMenu(state: IState) {
      state.menu = [];
    },
    setSubscriptionData(state: IState, subscriptionData: PushSubscription) {
      state.subscriptionData = subscriptionData;
    },
    setTokenRefreshing(state: IState, isTokenRefreshing: boolean) {
      localStorage.setItem( 'isTokenRefreshing', isTokenRefreshing.toString() );
    },
    addOnDemandApplication(state: IState, onDemandApplication: IApplication) {
      state.onDemandApplications.push( {
        ...onDemandApplication,
        loaded: false,
        loading: false,
        rejected: false,
        unloaded: false,
        onLoad: new Subject<any>()
      } );
    },
    // setNotifyMessages(state: IState, notifyMessages: Array<NotificationDto>) {
    //   state.notifyMessages = notifyMessages;
    // },
    // addNotifyMessage(state: IState, notifyMessage: NotificationDto) {
    //   state.notifyMessages.unshift(notifyMessage);
    // },
    // clearNotifyMessages(state: IState) {
    //   state.notifyMessages = [];
    // },
    setThemeName(state: IState, themeName: string) {
      GlobalStore.commit('setThemeName', themeName);
    },
    setIsMenuCompact(state: IState, isMenuCompact: boolean) {
      GlobalStore.commit('setIsMenuCompact', isMenuCompact);
    },
    setSettings(state: IState, settings: ISettings) {
      state.settings = settings;
      GlobalStore.commit('setMapSettings', settings);
    },
    setIsForeign(state: IState, status: boolean) {
      state.isForeign = status;
    },
    setLinkSettings(state: IState, link: string) {
      state.linkSettings = link;
    },
    setLinkDownloadApp(state: IState, link: string) {
      state.linkDownloadApp = link;
    }
  },
  actions: {
    loadSettings(context: ActionContext<IState, any>) {
      return new Promise<MapSettings>((resolve, reject) => {
        const params: any = {
          page: 0,
          size: 1000,
          sort: 'name,asc',
        };

        mapSettingsService.findAll(params).then((response: Pageable<MapSettings>) => {
          if (response.data && response.data?.length > 0) {
            const settings = response.data[0];
            const deserializedSettings = settings.deserialize();

            context.commit('setSettings', deserializedSettings);
            resolve(settings);
          } else {
            reject();
          }
        }).catch(() => {
          reject();
        });
      });
    }
  },
  modules: {
    themeModule: ThemeModule
  },
  getters: {
    authData: (state: IState): IAuthData | undefined => {
      return state.authData;
    },
    authDataCached: (state: IState): IAuthData | undefined => {
      const rawData = localStorage.getItem( 'authData' );
      if ( rawData )
        return JSON.parse( rawData );

      return undefined;
    },
    menu: (state: IState): IMenuEntity[] => {
      return state.menu;
    },
    isServicesLoading: (state: IState): boolean => {
      return state.isServicesLoading;
    },
    subscriptionData: (state: IState): PushSubscription | undefined => {
      return state.subscriptionData;
    },
    isTokenRefreshing: (state: IState): boolean | undefined => {
      const raw: unknown = localStorage.getItem('isTokenRefreshing');
      if ( raw != null )
        return raw == 'true';

      return undefined;
    },
    getOnDemandApplications: (state: IState): Array<IApplication> => {
      return state.onDemandApplications;
    },
    onAuth: (state: IState): Subject<IAuthData> => {
      return state.onAuth;
    },
    isAuthenticated: (state: IState): boolean => {
      return state.isAuthenticated;
    },
    getHeaderInfo: (state: IState): IHeaderInfo => {
      return GlobalStore.getters.headerInfo;
    },
    systems: (state: IState): ModuleSystem[] => {
      return state.systems;
    },
    // notifyMessages: (state: IState): NotificationDto[] => {
    //   return state.notifyMessages;
    // },
    themeName: (state: IState): string => {
      return GlobalStore.getters.themeName;
    },
    isMenuCompact: (state: IState): boolean => {
      return GlobalStore.getters.isMenuCompact;
    },
    authRoles: (state: IState): string[] => {
      if ( !state.authData || !state.authData.groups || !Array.isArray(state.authData.groups) ) return [];
      let roles: string[] = [];
      for (const group of state.authData.groups) {
        roles = roles.concat(group.roles);
      }
      return roles;
    },
    authGroups: (state: IState): string[] => {
      if ( !state.authData || !state.authData.groups || !Array.isArray(state.authData.groups) ) return [];
      let groups: string[] = [];
      for (const group of state.authData.groups) {
        groups = groups.concat(group.name);
      }
      return groups;
    },
    hasRole: (state: IState, getters: any) => (role: string): boolean => {
      const authRoles = getters.authRoles as string[];
      return authRoles.includes(role);
    },
    hasAnyRole: (state: IState, getters: any) => (roles: string[]): boolean => {
      if ( !Array.isArray( roles ) ) return false;
      const authRoles = getters.authRoles as string[];
      for (const role of roles) {
        if (authRoles.includes(role)) {
          return true;
        }
      }
      return false;
    },
    hasGroup: (state: IState, getters: any) => (group: string): boolean => {
      const authGroups = getters.authGroups as string[];
      return authGroups.includes(group);
    },
    hasAnyGroup: (state: IState, getters: any) => (groups: string[]): boolean => {
      if ( !Array.isArray( groups ) ) return false;
      const authGroups = getters.authGroups as string[];
      for (const group of groups) {
        if (authGroups.includes(group)) {
          return true;
        }
      }
      return false;
    },
    breadcrumbs: (state: IState): BreadcrumbsConfig => {
      return GlobalStore.getters.breadcrumbs;
    },
    settings: (state: IState): ISettings | null => {
      return state.settings;
    },
  }
})

interface IState {
  authData: IAuthData | undefined;
  isAuthenticated: boolean;
  menu: Array<IMenuEntity>;
  totalServices: number;
  processedServices: number;
  isServicesLoading: boolean;
  isServicesLoaded: boolean;
  subscriptionData: PushSubscription | undefined;
  onDemandApplications: Array<IOnDemandApplication>;
  onAuth: Subject<IAuthData>;
  systems: Array<ModuleSystem>;
  settings: ISettings | null;
  isForeign: boolean;
  linkDownloadApp: string | null;
  linkSettings: string | null;
}
